export default __webpack_public_path__ + "static/media/README.e1b98710.md";